import { StringListWithLocaleDto, StringWithLocaleDto } from '@api/dtos';
import { LocaleStore } from './i18n-store';
import { injectTSDI } from './tsdi';
import { StudioStore } from './studio-store';

const findValueWithFullLocale = (
    localizedValues?: StringWithLocaleDto[],
    locale?: string
) => localizedValues?.find((value) => value.locale === locale)?.value;

const findListValueWithFullLocale = (
    localizedValues?: StringListWithLocaleDto[],
    locale?: string
) => localizedValues?.find((value) => value.locale === locale)?.value;

const findValueWithLanguagePartOfLocale = (
    localizedValues?: StringWithLocaleDto[],
    language?: string
) =>
    localizedValues?.find((value) => value?.locale?.split('_')[0] === language)
        ?.value;

const findListValueWithLanguagePartOfLocale = (
    localizedValues?: StringListWithLocaleDto[],
    language?: string
) =>
    localizedValues?.find((value) => value?.locale?.split('_')[0] === language)
        ?.value;

export const findDisplayValues = (
    localizedListValues?: StringListWithLocaleDto[]
) => {
    const { currentLocale } = injectTSDI(LocaleStore);
    const { studioLocale } = injectTSDI(StudioStore);

    return (
        findListValueWithFullLocale(
            localizedListValues,
            currentLocale?.replace('-', '_')
        ) ??
        findListValueWithFullLocale(localizedListValues, studioLocale) ??
        findListValueWithLanguagePartOfLocale(
            localizedListValues,
            currentLocale?.split('-')[0]
        ) ??
        (localizedListValues ?? [])[0]?.value ??
        []
    );
};

export const findDisplayValue = (
    localizedValues?: StringWithLocaleDto[]
): string | undefined => {
    if (!localizedValues) {
        return '';
    }
    const { currentLocale } = injectTSDI(LocaleStore);
    const { studioLocale } = injectTSDI(StudioStore);

    return (
        findValueWithFullLocale(
            localizedValues,
            currentLocale?.replace('-', '_')
        ) ??
        findValueWithFullLocale(localizedValues, studioLocale) ??
        findValueWithLanguagePartOfLocale(
            localizedValues,
            currentLocale?.split('-')[0]
        ) ??
        (studioLocale &&
            findValueWithLanguagePartOfLocale(
                localizedValues,
                studioLocale?.split('_')[0]
            )) ??
        (localizedValues ?? [])[0]?.value ??
        ''
    );
};
